
import store from "@/store"
import organisations from "@/store/modules/system/Organisations.js";
import assessmentSettings from "@/store/modules/system/AssessmentSettings.js";
import users from "@/store/modules/system/Users.js";
import surveys from "@/store/modules/system/Surveys.js";
import userManagement from "@/store/modules/system/UserManagement.js";


const modules = {
    "surveys": surveys,
    "organisations": organisations,
    "users": users,
    "assessmentSettings": assessmentSettings,
    "userManagement": userManagement
}

const actions = {
  registerModules(){
    Object.keys(modules).forEach( m => {
      if( !store.hasModule(m) ){
        store.registerModule(m, modules[m]);
      }
    })
  },
  unregisterModules(){
    modules.forEach( m => {
      if( store.hasModule(m) ){
        store.unregisterModule(m)
      }
    })
  },
} 

export default {
  actions,
};
